import { call, put, takeLatest } from 'redux-saga/effects';
import { request } from 'utils/request';
import { emailsGridActions } from './slice';
import { notificationAlertActions } from 'app/pages/NotificationAlert/slice';
import { header } from 'utils/auth';



export function* getEmailTemplates({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v2/templates?dealer=${payload.dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (response.statusCode === 500) {
      yield put(emailsGridActions.requestEmailTemplatesError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Email templates fetch failed',
        }),
      );
    }

    yield put(emailsGridActions.requestEmailTemplatesSuccess(response));
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(
        emailsGridActions.requestEmailTemplatesError(err.response),
      );
    } else if (err.message === 'Server Error') {
      yield put(
        emailsGridActions.requestEmailTemplatesError(err.response),
      );
    } else {
      yield put(emailsGridActions.requestEmailTemplatesError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Email templates fetch failed',
      }),
    );
  }
}

export function* deleteEmailTemplate({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v2/templates/${payload.emailTemplateId}?dealer=${payload.dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'DELETE',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (response.statusCode === 500) {
      yield put(emailsGridActions.requestDeleteEmailTemplateError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Email template delete failed',
        }),
      );
    }

    yield put(emailsGridActions.requestDeleteEmailTemplateSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Email template deleted',
      }),
    );
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(
        emailsGridActions.requestDeleteEmailTemplateError(err.response),
      );
    } else if (err.message === 'Server Error') {
      yield put(
        emailsGridActions.requestDeleteEmailTemplateError(err.response),
      );
    } else {
      yield put(emailsGridActions.requestDeleteEmailTemplateError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Email template delete failed',
      }),
    );
  }
}

export function* updateEmailTemplate({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v2/templates/${payload.emailTemplateId}?dealer=${payload.dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'PUT',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify(payload.data)
    });

    if (response.statusCode === 500) {
      yield put(emailsGridActions.requestUpdateEmailTemplateError(response));

      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Email template update failed',
        }),
      );
    }

    yield put(emailsGridActions.requestUpdateEmailTemplateSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Email template updated',
      }),
    );
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(
        emailsGridActions.requestUpdateEmailTemplateError(err.response),
      );
    } else if (err.message === 'Server Error') {
      yield put(
        emailsGridActions.requestUpdateEmailTemplateError(err.response),
      );
    } else {
      yield put(emailsGridActions.requestUpdateEmailTemplateError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Email template update failed',
      }),
    );
  }
}

export function* approveEmailTemplate({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v2/templates/${payload.emailTemplateId}/approve?dealer=${payload.dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (response.statusCode === 500 || response?.statusCode >= 400) {
      yield put(emailsGridActions.requestApproveEmailTemplateError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: response?.message || 'Template approval failed',
        }),
      );
    }

    yield put(emailsGridActions.requestApproveEmailTemplateSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Template approved successfully',
      }),
    );
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(emailsGridActions.requestApproveEmailTemplateError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(emailsGridActions.requestApproveEmailTemplateError(err.response));
    } else {
      yield put(emailsGridActions.requestApproveEmailTemplateError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Template approval failed',
      }),
    );
  }
}

export function* rejectEmailTemplate({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v2/templates/${payload.emailTemplateId}/reject?dealer=${payload.dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
    });

    if (response.statusCode === 500 || response?.statusCode >= 400) {
      yield put(emailsGridActions.requestRejectEmailTemplateError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: response?.message || 'Template rejection failed',
        }),
      );
    }

    yield put(emailsGridActions.requestRejectEmailTemplateSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: 'Template rejected successfully',
      }),
    );
  } catch (err: any) {
    if (err.response?.status === 404) {
      yield put(emailsGridActions.requestRejectEmailTemplateError(err.response));
    } else if (err.message === 'Server Error') {
      yield put(emailsGridActions.requestRejectEmailTemplateError(err.response));
    } else {
      yield put(emailsGridActions.requestRejectEmailTemplateError(err));
    }
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: 'Template rejection failed',
      }),
    );
  }
}

export function* generateEmailTemplates({ payload }: ReturnType<any>) {
  try {
    const requestURL = `/api/v2/mia/templates/generate`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify({ dealer_id: payload.dealerId }),
    });

    if (response?.statusCode === 500 || response?.statusCode >= 400) {
      const message =
        response?.message ||
        response?.error ||
        'Email template generation failed';
      yield put(emailsGridActions.requestGenerateEmailTemplatesError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: typeof message === 'string' ? message : 'Email template generation failed',
        }),
      );
    }

    yield put(emailsGridActions.requestGenerateEmailTemplatesSuccess());
  } catch (err: any) {
    const message =
      err?.response?.data?.message ||
      err?.message ||
      'Email template generation failed';
    yield put(emailsGridActions.requestGenerateEmailTemplatesError(err));
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: typeof message === 'string' ? message : 'Email template generation failed',
      }),
    );
  }
}

export function* deleteEmailTemplates({ payload }: ReturnType<any>) {
  try {
    const { dealerId, ids } = payload as { dealerId: string; ids: string[] };
    if (!dealerId || !ids?.length) {
      yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Dealer and template IDs are required',
        }),
      );
      yield put(emailsGridActions.requestDeleteEmailTemplatesError({ message: 'Invalid payload' }));
      return;
    }
    let successCount = 0;
    for (const id of ids) {
      const requestURL = `/api/v2/templates/${id}?dealer=${dealerId}`;
      const response = yield call(request, requestURL, {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json',
          Authorization: header(),
        }),
      });
      if (response?.statusCode === 500 || (response?.statusCode && response.statusCode >= 400)) {
        const message = response?.message || response?.error || 'Failed to delete templates';
        yield put(emailsGridActions.requestDeleteEmailTemplatesError(response));
        return yield put(
          notificationAlertActions.addNotification({
            open: true,
            severity: 'error',
            message: typeof message === 'string' ? message : 'Failed to delete templates',
          }),
        );
      }
      successCount += 1;
    }
    const msg = successCount === 1 ? '1 template deleted' : `${successCount} templates deleted`;
    yield put(emailsGridActions.requestDeleteEmailTemplatesSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: msg,
      }),
    );
  } catch (err: any) {
    const message = err?.response?.data?.message || err?.message || 'Failed to delete templates';
    yield put(emailsGridActions.requestDeleteEmailTemplatesError(err));
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: typeof message === 'string' ? message : 'Failed to delete templates',
      }),
    );
  }
}

export function* expireEmailTemplates({ payload }: ReturnType<any>) {
  try {
    const { dealerId, ids } = payload as { dealerId: string; ids: string[] };
    if (!dealerId || !ids?.length) {
      yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Dealer and template IDs are required',
        }),
      );
      yield put(emailsGridActions.requestExpireEmailTemplatesError({ message: 'Invalid payload' }));
      return;
    }
    const requestURL = `/api/v2/templates/expire?dealer=${dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'DELETE',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify({ ids }),
    });

    if (response?.statusCode === 500 || response?.statusCode >= 400) {
      const message = response?.message || response?.error || 'Failed to expire templates';
      yield put(emailsGridActions.requestExpireEmailTemplatesError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: typeof message === 'string' ? message : 'Failed to expire templates',
        }),
      );
    }

    const modifiedCount = response?.data?.modifiedCount ?? ids.length;
    const msg = modifiedCount === 1 ? '1 template expired' : `${modifiedCount} templates expired`;
    yield put(emailsGridActions.requestExpireEmailTemplatesSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: msg,
      }),
    );
  } catch (err: any) {
    const message = err?.response?.data?.message || err?.message || 'Failed to expire templates';
    yield put(emailsGridActions.requestExpireEmailTemplatesError(err));
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: typeof message === 'string' ? message : 'Failed to expire templates',
      }),
    );
  }
}

export function* bulkApproveEmailTemplates({ payload }: ReturnType<any>) {
  try {
    const { dealerId, ids } = payload as { dealerId: string; ids: string[] };
    if (!dealerId || !ids?.length) {
      yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Dealer and template IDs are required',
        }),
      );
      yield put(
        emailsGridActions.requestBulkApproveEmailTemplatesError({ message: 'Invalid payload' }),
      );
      return;
    }

    const requestURL = `/api/v2/templates/approve/bulk?dealer=${dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify({ ids }),
    });

    if (response?.statusCode === 500 || (response?.statusCode && response.statusCode >= 400)) {
      const message = response?.message || response?.error || 'Template approval failed';
      yield put(emailsGridActions.requestBulkApproveEmailTemplatesError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: typeof message === 'string' ? message : 'Template approval failed',
        }),
      );
    }

    const msg =
      response?.message ||
      (ids.length === 1 ? '1 template approved' : `${ids.length} templates approved`);
    yield put(emailsGridActions.requestBulkApproveEmailTemplatesSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: msg,
      }),
    );
  } catch (err: any) {
    const message = err?.message || 'Template approval failed';
    yield put(emailsGridActions.requestBulkApproveEmailTemplatesError(err));
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: typeof message === 'string' ? message : 'Template approval failed',
      }),
    );
  }
}

export function* bulkRejectEmailTemplates({ payload }: ReturnType<any>) {
  try {
    const { dealerId, ids } = payload as { dealerId: string; ids: string[] };
    if (!dealerId || !ids?.length) {
      yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: 'Dealer and template IDs are required',
        }),
      );
      yield put(
        emailsGridActions.requestBulkRejectEmailTemplatesError({ message: 'Invalid payload' }),
      );
      return;
    }

    const requestURL = `/api/v2/templates/reject/bulk?dealer=${dealerId}`;
    const response = yield call(request, requestURL, {
      method: 'POST',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: header(),
      }),
      body: JSON.stringify({ ids }),
    });

    if (response?.statusCode === 500 || (response?.statusCode && response.statusCode >= 400)) {
      const message = response?.message || response?.error || 'Template rejection failed';
      yield put(emailsGridActions.requestBulkRejectEmailTemplatesError(response));
      return yield put(
        notificationAlertActions.addNotification({
          open: true,
          severity: 'error',
          message: typeof message === 'string' ? message : 'Template rejection failed',
        }),
      );
    }

    const msg =
      response?.message ||
      (ids.length === 1 ? '1 template rejected' : `${ids.length} templates rejected`);
    yield put(emailsGridActions.requestBulkRejectEmailTemplatesSuccess());
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'success',
        message: msg,
      }),
    );
  } catch (err: any) {
    const message = err?.message || 'Template rejection failed';
    yield put(emailsGridActions.requestBulkRejectEmailTemplatesError(err));
    return yield put(
      notificationAlertActions.addNotification({
        open: true,
        severity: 'error',
        message: typeof message === 'string' ? message : 'Template rejection failed',
      }),
    );
  }
}

export function* uploadLeadsDetailsSaga() {
  yield takeLatest(
    emailsGridActions.requestEmailTemplates.type,
    getEmailTemplates,
  );
  yield takeLatest(
    emailsGridActions.requestDeleteEmailTemplate.type,
    deleteEmailTemplate,
  );
  yield takeLatest(
    emailsGridActions.requestUpdateEmailTemplate.type,
    updateEmailTemplate,
  );
  yield takeLatest(
    emailsGridActions.requestApproveEmailTemplate.type,
    approveEmailTemplate,
  );
  yield takeLatest(
    emailsGridActions.requestRejectEmailTemplate.type,
    rejectEmailTemplate,
  );
  yield takeLatest(
    emailsGridActions.requestGenerateEmailTemplates.type,
    generateEmailTemplates,
  );
  yield takeLatest(
    emailsGridActions.requestExpireEmailTemplates.type,
    expireEmailTemplates,
  );
  yield takeLatest(
    emailsGridActions.requestDeleteEmailTemplates.type,
    deleteEmailTemplates,
  );
  yield takeLatest(
    emailsGridActions.requestBulkApproveEmailTemplates.type,
    bulkApproveEmailTemplates,
  );
  yield takeLatest(
    emailsGridActions.requestBulkRejectEmailTemplates.type,
    bulkRejectEmailTemplates,
  );
}
